module.exports = __webpack_public_path__ + "img/f_u2_academycoat.38fbc818.jpg";